import { PseudoElementSelector } from "./pseudo-element.js";
/**
 *{@link https://drafts.csswg.org/css-pseudo-4/#file-selector-button-pseudo}
 */
export class FileSelectorButton extends PseudoElementSelector {
    static of() {
        return new FileSelectorButton();
    }
    constructor() {
        super("file-selector-button");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (FileSelectorButton) {
    FileSelectorButton.parse = PseudoElementSelector.parseNonLegacy("file-selector-button", FileSelectorButton.of);
})(FileSelectorButton || (FileSelectorButton = {}));
//# sourceMappingURL=file-selector-button.js.map